var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConversations = function SvgConversations(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M14 4H6a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h1.5v3l4.5-3h6a3 3 0 0 0 3-3v-5M20.414 6.414a2 2 0 1 1-2.828-2.828 2 2 0 0 1 2.828 2.828"
  })));
};
export { SvgConversations as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiMmEwZWZmZjg4NzllMzVjNDg4NTRjY2YzZGRiNzc5M2Uuc3ZnIjs=";